import { w } from '@/lib/api'

export const resetPasswordMutation = {
  mutationFn: (data: { email: string }) => w.post(data, '/business/v1/auth/password/reset').json(),
}
